/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/**
 * @file loginView.jsx
 * @author Fernando Ruano
 * @description StepTwo View Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, Alert, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

// Components
import LoginTemplate from '@nephro/components/LoginTemplate';

// Helpers
import { getStorageItem } from '@nephro/commons/helpers/storage-helper';
import { validatePassword } from '@nephro/commons/helpers/utils';

// Styles
import styles from './styles.module.css';

function stepTwoView({ authActions, loading }) {
  const { t: translate } = useTranslation();
  // const [currentTab, setCurrentTab] = React.useState('staff');
  const [isError, setIsError] = React.useState(false);
  const [messageError, setMessageError] = React.useState(null);
  const history = useHistory();
  const location = useLocation();
  const [form] = Form.useForm();

  const { passwordResetRegister } = authActions;

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: translate('commons.required'),
    types: {
      email: translate('commons.wrongEmail')
    }
  };
  /* eslint-enable no-template-curly-in-string */

  const onNavigationBack = () => {
    history.replace('/login');
  };

  React.useEffect(() => {
    if (getStorageItem('user')) {
      onNavigationBack();
    }
  }, []);

  // Validate if password reset was OK
  const onValidate = (type, response) => {
    if (type === 'success') {
      notification.success({
        message: translate('registration.notification'),
        description: translate('registration.succesPass')
      });

      history.push('/registration/stepThree', location.state);
    } else {
      setMessageError(
        response.code !== undefined
          ? `errors.${response.code}P`
          : 'commons.problem'
      );
      setIsError(true);
    }
  };

  // After press continue button when form full filled
  const onFinish = (values) => {
    setIsError(false);
    const { confirmPass } = values;
    const data = {
      identificationDocument: location?.state?.document,
      documentType: location?.state?.docType,
      email: location?.state?.email,
      userNewPassword: confirmPass
    };

    passwordResetRegister(data, onValidate);
  };

  // After press continue button whit errors in form
  const onFinishFailed = () => setIsError(false);

  // Validate confirmation password
  const validateConfirmPas = (rule, value, callback) => {
    const { password, confirmPass } = form.getFieldsValue();
    if (password !== confirmPass)
      return callback('Las contraseñas no coinciden');
    return Promise.resolve();
  };

  return (
    <LoginTemplate
      loading={loading}
      title="registration.createTitle"
      textContent="registration.createContent">
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onFieldsChange={onFinishFailed}
        validateMessages={validateMessages}>
        <Form.Item
          label={translate('login.password')}
          name="password"
          className="w-full"
          rules={[
            {
              required: true
            },
            {
              validator: validatePassword
            }
          ]}>
          <Input.Password
            autoComplete="off"
            className="h-10"
            placeholder={translate('login.password')}
          />
        </Form.Item>

        <Form.Item
          label={translate('registration.confirmPass')}
          name="confirmPass"
          className="w-full"
          rules={[
            {
              required: true
            },
            {
              validator: validateConfirmPas
            }
          ]}>
          <Input.Password
            autoComplete="off"
            className="h-10"
            placeholder={translate('login.password')}
          />
        </Form.Item>

        {isError && (
          <div className="mb-4 -mt-4">
            <Alert message={translate(messageError)} type="error" showIcon />
          </div>
        )}
        <div className="flex flex-row justify-between">
          <Form.Item className="w-full">
            <Button
              onClick={onNavigationBack}
              type="link"
              className={styles.stepTwoButton}>
              {translate('commons.cancel')}
            </Button>
          </Form.Item>
          <Form.Item className="w-full">
            <Button
              className={styles.stepTwoButton}
              type="primary"
              htmlType="submit">
              {translate('registration.continue')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </LoginTemplate>
  );
}

/**
 * Component definition of proptypes.
 */
stepTwoView.propTypes = {
  authActions: PropTypes.shape({
    resetPassword: PropTypes.func.isRequired
  }).isRequired,
  patientActions: PropTypes.shape({
    updatePatientStatus: PropTypes.func.isRequired
  }).isRequired,
  loading: PropTypes.bool.isRequired
};

export default stepTwoView;
